import { render, staticRenderFns } from "./GameTrackingPage.vue?vue&type=template&id=32f59e44&scoped=true"
import script from "./GameTrackingPage.vue?vue&type=script&lang=js"
export * from "./GameTrackingPage.vue?vue&type=script&lang=js"
import style0 from "./GameTrackingPage.vue?vue&type=style&index=0&id=32f59e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f59e44",
  null
  
)

export default component.exports